/**
 * Created by pskwira on 08.11.2018.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', '../utils'], function($, _, EventEmitter, Utils){

    var HiresSearchConfig = {
        itemNumberField: "#productSearchNumber",
        searchResultsWrapper: ".search-results",
        searchResultsId: "#hiResSearch",
        searchResults: ".results",
        searchPreloader: "#hiresLoader",
        filtersRowId: "#filtersRow",
        shareOverlayId: '#shareOverlay',
        inputFieldCheckbox: '.input-field--checkbox',
        resetButton: '.reset-button'
    }

    function HiresSearch(overlaysInstance){

        var _this = this;

        this.overlaysInstance = overlaysInstance;

        $(document).on({
            click: function (e) {
                _this.downloadAction(e);
            }
        }, '#download-accept');

        $(document).on({
            click: function (e) {
                if ( _this.$input.val() != '' && _this.clicked != true ) {
                    _this.clicked = true;
                    _this.search();
                }
            }
        }, '#input__icon');

        $(document).on({
            keyup: function (e) {

                _this.$input.val(e.target.value);

                if(e.keyCode == 13 && _this.$input.val() != '' && _this.clicked != true)
                {
                    _this.clicked = true;
                    _this.search();
                }

            }
        }, '#productSearchNumber');

        $(document).on({
            change: function(e) {
                _this.clicked = true;
                _this.fetchWithParams(e, 'group');
            }
        }, '#hiResSearchFormat');

        $(document).on({
            change: function(e) {
                _this.clicked = true;
                _this.fetchWithParams(e, 'woodColor');
            }
        }, '#colorsQuery');

        $(document).on({
            click: function() {
                _this.clicked = true;
                _this.resetForm();
            }
        }, '.reset-button');

        $(document).on({
            click: function (e) {
                e.preventDefault();
                var $element = _this.$shareOverlayId.find('#download-accept').get(0);
                $($element).prop("href", e.currentTarget.getAttribute('data-href'));
            }
        }, '.teaser__hires_item');

    }

    HiresSearch.prototype = _.clone(EventEmitter.prototype);

    HiresSearch.prototype.init = function(){

        this.$input = $(HiresSearchConfig.itemNumberField);
        this.$resultsWrapper = $(HiresSearchConfig.searchResultsWrapper);
        this.$searchResults = $(HiresSearchConfig.searchResults);
        this.$searchResultsId = $(HiresSearchConfig.searchResultsId);
        this.$preloader = $(HiresSearchConfig.searchPreloader);
        this.$filtersRowId = $(HiresSearchConfig.filtersRowId);

        this.$shareOverlayId = $(HiresSearchConfig.shareOverlayId);

        this.clicked = false;

        // this.bindEvents();

    };

    // HiresSearch.prototype.bindEvents = function(){}

    HiresSearch.prototype.search = function() {

        var _this = this;

        _this.$preloader.removeClass('preloader--hidden');

        var currentPageUrl = window.location.href;

        var groupInUrl = Utils.getQueryStringParams('group', currentPageUrl);
        var woodColorParam = Utils.getQueryStringParams('woodColor', currentPageUrl);

        if(groupInUrl){
            currentPageUrl = Utils.removeURLParameter(currentPageUrl, 'group');
        }


        if(woodColorParam){
            currentPageUrl = Utils.removeURLParameter(currentPageUrl, 'woodColor');
        }

        var newUrlValue = window.location.origin+window.location.pathname+ ( (_this.$input.val() !== '' ) ? '?itemNumber=' + _this.$input[0].value.replace(/ /g, '') : '')

        $.ajax({
            type: "GET",
            url: newUrlValue
        }).done(function( data ) {
            _this.switchContent(data, newUrlValue);
        });

    };

    HiresSearch.prototype.fetchWithParams = function(e, select) {

        var _this = this;

        _this.$preloader.removeClass('preloader--hidden');

        var currentPageUrl = window.location.href;

        var itemNumberInUrl = Utils.getQueryStringParams('itemNumber', currentPageUrl);
        var groupInUrl = Utils.getQueryStringParams('group', currentPageUrl);
        var woodColorParam = Utils.getQueryStringParams('woodColor', currentPageUrl);

        currentPageUrl = ( itemNumberInUrl ) ? Utils.removeURLParameter(currentPageUrl, 'itemNumber') : currentPageUrl;

        if(groupInUrl && select == 'group'){
            currentPageUrl = Utils.removeURLParameter(currentPageUrl, 'group');
        }

        if( woodColorParam || woodColorParam == '' ){
            currentPageUrl = Utils.removeURLParameter(currentPageUrl, 'woodColor');
        }

        var currentValue = e.currentTarget.options[e.currentTarget.selectedIndex].value

        var newUrlValue = Utils.addQueryStringParamsToUrl(select, currentValue, currentPageUrl);

        $.ajax({
            type: "GET",
            url: newUrlValue
        }).done(function( data ) {
            _this.switchContent(data, newUrlValue);
        });

    };

    HiresSearch.prototype.resetForm = function() {
        var _this = this;
        var currentPageUrl = window.location.origin + window.location.pathname;

        _this.$preloader.removeClass('preloader--hidden');

        $.ajax({
            type: "GET",
            url: currentPageUrl
        }).done((data) => {
            this.switchContent(data, currentPageUrl);
        });
    };

    HiresSearch.prototype.switchContent = function(data, url) {

        var _this = this;

        var $data = $(data);
        var $contentFiltersHTML = $data.find(HiresSearchConfig.filtersRowId).contents();
        var $contentHTML = $data.find(HiresSearchConfig.searchResultsId).contents();

        _this.$searchResultsId.html($contentHTML);
        _this.$filtersRowId.html($contentFiltersHTML);
        _this.clicked = false;
        _this.$preloader.addClass('preloader--hidden');

        _this.emit('hiResResults', url);

    }

    HiresSearch.prototype.downloadAction = function(e) {

        var _this = this;

        var isChecked = $(_this.$shareOverlayId).find('#qwe1111').prop("checked");

        if (!isChecked) {

            e.preventDefault();
            _this.$shareOverlayId.find(HiresSearchConfig.inputFieldCheckbox).addClass('input-field--error');

        } else {

            _this.$shareOverlayId.find(HiresSearchConfig.inputFieldCheckbox).removeClass('input-field--error');

            var overlayCloseEvent = new Event('forceHideOverlay');
            window.dispatchEvent( overlayCloseEvent );

        }

    }

    return HiresSearch;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/highresSearch.js